import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <h1>Dashboard Page</h1>
      <p>Welcome to the Dashboard!</p>
    </div>
  );
};

export default Dashboard;